<template>
  <div class="mobile_picker">
    <img
      v-on:click="hideItems()"
      class="close_icon clicky"
      src="/assets/icons/RS-PPE-ICONS-CROSS.svg"
      alt
      width="40"
    />
    <h2>{{ item_copy_title }}</h2>
    <p>{{ item_description }}</p>
    <a
      class="primary_btn btn_shop"
      target="_blank"
      v-if="item_link"
      :href="item_link"
    >{{ $t('buttons.see_product_button') }}</a>
    <a class="primary_btn select_btn" href>Wählen</a>
    <ul>
      <li
        v-on:click="updateInfo(item.title, item.description, item.link)"
        v-bind:key="item.id"
        v-for="item in scenarios"
        :data-target="item.target"
        :data-level="item.level"
        :data-id="item.id"
        :class="[{hidden: item.id === 'bui-gloves' && which_level === 'logistics'}, {hidden: item.id === 'log-gloves' && which_level === 'construction'}, {hidden: item.id === 'log-gloves' && which_level != 'logistics'}, {active_item: item.title === item_copy_title}, {hidden: $store.state.mobile_current_target === 'CIRCLE-RIGHT-HAND' && item.target != 3}, {hidden: $store.state.mobile_current_target === 'CIRCLE-HEAD' && item.target != 1}, {hidden: $store.state.mobile_current_target === 'CIRCLE-BODY' && item.target != 2}, {hidden: $store.state.mobile_current_target === 'CIRCLE-FEET' && item.target != 4}]"
      >
        <img :src="item.url" alt />
        <img
          src="/assets/icons/ok.svg"
          :id="'img-'+item.id"
          alt
          class="hide_icon ok_mobile"
          style="width: 20px;"
        />
      </li>
      <li style="height:0px;"></li>
      <li style="height:0px;"></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "AppMobilePicker",
  props: ["scenarios"],
  data() {
    return {
      item_link: "",
      item_copy_title: "",
      item_description: "",
      which_level: ""
    };
  },
  methods: {
    updateInfo: function(title, description, link) {
      this.item_link = link;
      this.item_copy_title = title;
      this.item_description = description;
    },
    hideItems: function() {
      document
        .querySelector(".mobile_picker")
        .classList.remove("picker_triggered");
    }
  },
  beforeMount() {
    // console.log(this.scenarios);
    // console.log(this.scenarios.buiBoots);
    this.item_link = this.scenarios[0].link;
    this.item_copy_title = this.scenarios[0].title;
    this.item_description = this.scenarios[0].description;
    this.which_level = this.$route.params.level;
  }
};
</script>

<style scoped>
.clicky {
  cursor: pointer;
}
.close_icon {
  position: relative;
  left: calc(100% - 26px);
}
.btn_shop {
  border: 1px solid #ef0000;
  transition: 0.2s;
  margin: 10px 0;
  display: inline-block;
  font-size: 1em;
  cursor: pointer;
  padding: 12px 50px;
  border-radius: 3px;
  letter-spacing: 0.1em;
  background-color: #fff;
  text-decoration: none;
  color: #ef0000;
  font-family: century-gothic, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
}
.hidden {
  display: none !important;
}
.active_item {
  filter: drop-shadow(7px 7px 7px #5f259f);
}
.hide_icon {
  display: none;
}
.correct_item {
  display: block !important;
}
.ok_mobile {
  width: 20px;
  position: relative;
  bottom: 88px;
  margin: 0 auto;
}
@media (min-width: 600px) and (max-width: 1024px) {
  .mobile_picker ul li img {
    height: 66%;
    width: auto;
  }
}
</style>
